import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/mobile/drop-icon-gift-dialog.png'
import _imports_1 from '@/assets/images/mobile/reward-rules-title-img.png'
import _imports_2 from '@/assets/images/mobile/gift-blue.png'
import _imports_3 from '@/assets/images/mobile/list-gifts-icon-1.png'
import _imports_4 from '@/assets/images/mobile/red-wrnning-red.png'


const _withScopeId = n => (_pushScopeId("data-v-4e228a04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "redeem-dialog pb-0" }
const _hoisted_2 = {
  key: 0,
  src: _imports_1,
  class: "img-cn-title mb-3",
  alt: "title"
}
const _hoisted_3 = {
  key: 1,
  class: "title text-black fw-semibold"
}
const _hoisted_4 = { class: "list-rules text-start px-3" }
const _hoisted_5 = { class: "list-rules-title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gift-icon d-flex justify-content-center align-items-center position-absolute rounded-circle" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "gift icon"
  })
], -1))
const _hoisted_7 = { class: "list-content" }
const _hoisted_8 = { class: "list-item" }
const _hoisted_9 = { class: "span-item" }
const _hoisted_10 = { class: "list-item" }
const _hoisted_11 = { class: "span-item" }
const _hoisted_12 = { class: "list-item" }
const _hoisted_13 = { class: "span-item" }
const _hoisted_14 = { class: "list-item" }
const _hoisted_15 = { class: "span-item" }
const _hoisted_16 = { class: "list-rules-title" }
const _hoisted_17 = { class: "list-content" }
const _hoisted_18 = { class: "list-item" }
const _hoisted_19 = { class: "list-item" }
const _hoisted_20 = { class: "list-rules-title" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gift-icon d-flex justify-content-center align-items-center position-absolute rounded-circle" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: "gift icon"
  })
], -1))
const _hoisted_22 = { class: "list-content" }
const _hoisted_23 = { class: "list-item" }
const _hoisted_24 = { class: "list-item" }
const _hoisted_25 = { class: "span-item" }
const _hoisted_26 = { class: "list-rules-title" }
const _hoisted_27 = { class: "list-content" }
const _hoisted_28 = { class: "list-item" }
const _hoisted_29 = { class: "list-item" }
const _hoisted_30 = { class: "red-warning rounded-3 mb-3" }
const _hoisted_31 = { class: "position-relative warning-text" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "position-absolute warr-icon",
  src: _imports_4,
  alt: "warnning icon"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _imports_0,
      class: "drop-icon",
      alt: "drop icon",
      role: "button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.hide_()))
    }),
    (_ctx.$route.query.lang?.toString().toLowerCase() == 'cn')
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : (_openBlock(), _createElementBlock("p", _hoisted_3, "Reward Rules")),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createTextVNode(_toDisplayString($setup.local.reward_rules_1) + " ", 1),
        _hoisted_6
      ]),
      _createElementVNode("ul", _hoisted_7, [
        _createElementVNode("li", _hoisted_8, [
          _createTextVNode(_toDisplayString($setup.local.reward_rules_2), 1),
          _createElementVNode("span", _hoisted_9, _toDisplayString($setup.local.reward_rules_3), 1),
          _createTextVNode(_toDisplayString($setup.local.reward_rules_4), 1)
        ]),
        _createElementVNode("li", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, _toDisplayString($setup.local.reward_rules_5), 1),
          _createTextVNode(_toDisplayString($setup.local.reward_rules_6), 1)
        ]),
        _createElementVNode("li", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, _toDisplayString($setup.local.reward_rules_7), 1),
          _createTextVNode(_toDisplayString($setup.local.reward_rules_8), 1)
        ]),
        _createElementVNode("li", _hoisted_14, [
          _createElementVNode("span", _hoisted_15, _toDisplayString($setup.local.reward_rules_9), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_16, _toDisplayString($setup.local.reward_rules_10), 1),
      _createElementVNode("ul", _hoisted_17, [
        _createElementVNode("li", _hoisted_18, _toDisplayString($setup.local.reward_rules_11), 1),
        _createElementVNode("li", _hoisted_19, _toDisplayString($setup.local.reward_rules_12), 1)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createTextVNode(_toDisplayString($setup.local.reward_rules_13) + " ", 1),
        _hoisted_21
      ]),
      _createElementVNode("ul", _hoisted_22, [
        _createElementVNode("li", _hoisted_23, _toDisplayString($setup.local.reward_rules_14), 1),
        _createElementVNode("li", _hoisted_24, [
          _createTextVNode(_toDisplayString($setup.local.reward_rules_15), 1),
          _createElementVNode("span", _hoisted_25, _toDisplayString($setup.local.reward_rules_16), 1),
          _createTextVNode(_toDisplayString($setup.local.reward_rules_17), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_26, _toDisplayString($setup.local.reward_rules_18), 1),
      _createElementVNode("ul", _hoisted_27, [
        _createElementVNode("li", _hoisted_28, _toDisplayString($setup.local.reward_rules_19), 1),
        _createElementVNode("li", _hoisted_29, _toDisplayString($setup.local.reward_rules_20), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", null, _toDisplayString($setup.local.reward_rules_21), 1),
        _hoisted_32
      ])
    ])
  ]))
}